import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getModosEmpleo, getUsosOrigen, removeUsos } from "../../../../../../redux/actions/resolucion";
import UsosTable from "./UsosTable";
import UsosFormContainer from "./form/UsosFormContainer";



const UsosTableContainer = ({ handleNextStep, handlePreviousStep, stepper }) => {
    const dispatch = useDispatch();
    const [openUsosForm, setOpenUsosForm] = useState(false);
    const [uso, setUso] = useState();
    const usos = useSelector((state) => state.resolucion.abmSustancia.usos);

    useEffect(() => {
        dispatch(getUsosOrigen());
        dispatch(getModosEmpleo());
    }, [])

    const handleGoNext = () => {
        handleNextStep();
    };

    const handleGoBack = () => {
        handlePreviousStep("Part4");
    }

    const handleOpenForm = (uso) => {
        setUso(uso);
        setOpenUsosForm(true);
    }
    const handleDelete = (data) => {
        dispatch(removeUsos(data.map((v) => v.index)));
    }


    return (
        <>
            <UsosTable
                handleGoBack={handleGoBack}
                handleGoNext={handleGoNext}
                data={usos}
                handleOpenForm={handleOpenForm}
                handleDelete={handleDelete}
                stepper={stepper}
            />
            <UsosFormContainer
                open={openUsosForm}
                formValues={uso}
                handleClose={() => setOpenUsosForm(false)}

            />
        </>

    )
}

export default UsosTableContainer;